import dayjs from "@/lib/helpers/dayjs";
import { Divider2 } from "@/ui2/atoms/Divider";
import type { PatientDetails } from "@/core/types";

import { PatientData } from "../(header)/components/PatientData";

import { AcuityScoreBadge } from "./components/AcuityScoreBadge";
import { ReportAcuity } from "./components/ReportAcuity";

type Props = {
  patientDetails: PatientDetails;
  patientId: string;
};

export function PatientAcuity({ patientDetails, patientId }: Props) {
  const { acuity_score, acuity_timestamp } = patientDetails;

  if (!acuity_score) return null;

  const formattedAcuityDate = acuity_timestamp
    ? dayjs(acuity_timestamp).format("M/D/YY")
    : undefined;

  return (
    <>
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-1">
        <dl className="tw:flex tw:flex-col tw:gap-2">
          <PatientData
            className="tw:flex tw:items-center"
            classNameChildren="tw:flex"
            label="Acuity Index"
          >
            <AcuityScoreBadge acuityIndex={acuity_score} />
          </PatientData>

          {formattedAcuityDate && (
            <PatientData
              className="tw:text-sm tw:text-text-tertiary tw:*:font-normal"
              label="Updated"
            >
              {formattedAcuityDate}
            </PatientData>
          )}
        </dl>

        <ReportAcuity patientId={patientId} />
      </div>

      <Divider2 className="tw:lg:-ml-4" />
    </>
  );
}
